export default {
  // add reducers that should be initially loaded by the store here
};
